app.controller("PollsIndexController", ["$scope", "$stateParams", "PollService", "$uibModal", "$state", "ConfirmModal", "toastr", "usSpinnerService",
    function ($scope, $stateParams, PollService, $uibModal, $state, ConfirmModal, toastr, usSpinnerService) {
        $scope.format = 'dd-MM-yyyy';
        $scope.polls = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;
        $scope.title = null;
        $scope.query = $stateParams.query;
        $scope.fromDate = $stateParams.fromDate ? new Date(parseInt($stateParams.fromDate)) : undefined;
        $scope.toDate = $stateParams.toDate ? new Date(parseInt($stateParams.toDate)) : undefined;
        $scope.owned = $stateParams.owned === 'true';

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.open = function (poll) {
            $uibModal.open({
                controller: "PollsWindowController",
                templateUrl: _pb + 'admin/polls/poll-window.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {poll: poll};
                    }
                }
            }).result
                .then(function (result) {

                }, function () {

                });
        };

        $scope.editPoll = function (poll) {
            $state.go("admin.createPolls", {
                operationType: 'edit',
                pollId: poll._id
            });
        };

        $scope.resendPoll = function (poll) {
            $state.go("admin.createPolls", {
                operationType: 'resend',
                pollId: poll._id
            });
        };

        $scope.remove = function (poll, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "ყურადღება",
                message: "გსურთ გამოკითხვის წაშლა ?"
            }).result.then(function () {
                PollService.remove(poll._id).then(function () {
                    toastr.success('', 'გამოკითხვა წაშლილია');
                    loadPage();
                });
            });
        };

        $scope.showStatistics = function (poll, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("admin.send.statistics", {'pollId': poll._id});
        };

        function loadPage(page, query, fromDate, toDate, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            PollService.sendList({
                page: page,
                query: query,
                fromDate: fromDate,
                toDate: toDate,
                limit: $scope.itemsPerPage,
                owned: $scope.owned
            }).then(function (data) {
                $scope.polls = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.create = function () {
            $state.go("admin.createPolls", {});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                fromDate: $scope.fromDate ? $scope.fromDate.getTime() : undefined,
                toDate: $scope.toDate ? $scope.toDate.getTime() : undefined ,
                owned: $scope.owned
            });
        };
    }
]);